import React from 'react'
import { MantineProvider, MantineProviderProps, v8CssVariablesResolver } from '@mantine/core'
import { theme as defaultTheme } from './create'

export const ThemeProvider: typeof MantineProvider = ({
  theme = defaultTheme,
  cssVariablesResolver = v8CssVariablesResolver,
  children,
  ...providerProps
}: MantineProviderProps) => (
  <MantineProvider theme={theme} cssVariablesResolver={cssVariablesResolver} {...providerProps}>
    {children}
  </MantineProvider>
)
ThemeProvider.displayName = 'ThemeProvider'
